import React, { useEffect, useState } from "react";
import { isEmpty, filter } from "lodash";
import { fetchLikedSongs, removeSongFromFavorites } from "../../actions/songs.actions";
import likedSongsStore from "../../zustand/likedSong.store";
import userStore from "../../zustand/user.store";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import { showToaster } from "../../helpers/toaster.helpers";
import MobileHeader from "../components/MobileHeader";
import MobileSongList from "../components/MobileSongList";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import styles from "./MobileLiked.module.scss";

const MobileLiked = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [songs, setSongs] = useState([]);
  const { deleteSong, addSong } = likedSongsStore();
  const { userOffline, isAuthenticated } = userStore((state) => ({
    userOffline: state.userOffline,
    isAuthenticated: state.isAuthenticated,
  }));
  const { setSongs: setPlayerSongs, setIsPlaying, setCurrentSongIndex } = musicPlayerStore();

  useEffect(() => {
    (async () => {
      if (!isAuthenticated || userOffline) return;
      setIsLoading(true);
      const data = await fetchLikedSongs();
      setSongs(data || []);
      setIsLoading(false);
    })();
  }, [isAuthenticated, userOffline]);

  const handleSongClick = (index) => {
    if (window.__4playEngine) window.__4playEngine.primeElements();
    setPlayerSongs(songs, index);
    setCurrentSongIndex(index);
    setIsPlaying(true);
  };

  const handleLikeClick = async (song, isAlreadyLiked) => {
    if (userOffline) return showToaster("error", "You are offline");
    if (isAlreadyLiked) {
      const old = [...songs];
      setSongs(filter(songs, (s) => s.id !== song.id));
      deleteSong(song.id);
      const ok = await removeSongFromFavorites({ song_id: song.id });
      if (!ok) { addSong(song.id); setSongs(old); }
    }
  };

  return (
    <div className={styles.page}>
      <MobileHeader title="Liked Songs" />
      {isLoading ? (
        <div className={styles.loader}>
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className={styles.skeletonItem}>
              <div className={`${styles.skeletonThumb} ${styles.skeletonPulse}`} />
              <div className={styles.skeletonInfo}>
                <div className={`${styles.skeletonTitle} ${styles.skeletonPulse}`} />
                <div className={`${styles.skeletonArtist} ${styles.skeletonPulse}`} />
              </div>
            </div>
          ))}
        </div>
      ) : isEmpty(songs) ? (
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>
            <Icons type={ICONS.LIKE_SONG_LIST} />
          </div>
          <p className={styles.emptyTitle}>No liked songs yet</p>
          <p className={styles.emptySubtext}>Tap the heart icon on any song to save it here</p>
        </div>
      ) : (
        <MobileSongList songs={songs} onSongClick={handleSongClick} onLikeClick={handleLikeClick} />
      )}
    </div>
  );
};

export default MobileLiked;
